import { buildImage } from '@luks/ui';
import { GatsbyImageProps } from 'gatsby-plugin-image';
import { memoize } from 'lodash';

export const buildDrupalImage = memoize(
  (
    image:
      | {
          id: unknown;
          styles: Array<{
            id: string;
            sources: Array<{
              width: number;
              height: number;
              url: string;
            }>;
          }>;
          alt?: unknown;
          focalPoint?: {
            x: number;
            y: number;
          };
        }
      | undefined,
    preset:
      | 'teaser'
      | 'content'
      | 'screen_fallback'
      | 'dual_screen_fallback'
      | 'image_gallery'
      | 'square_teaser'
      | 'testimonial'
      | 'hero'
      | 'gatsby_content_xl',
    sizes: string = '(min-width: 430px): 768px',
    gatsbyProps: Omit<GatsbyImageProps, 'alt' | 'image'> = {},
  ) => {
    const styles = [
      ...(image?.styles
        .filter((style) => style.id === preset)
        .map((style) => style.sources)[0] || []),
    ];

    const objectPosition =
      gatsbyProps.objectPosition ||
      (image?.focalPoint
        ? `${image.focalPoint.x}% ${image.focalPoint.y}%`
        : '50% 50%');

    if (!image?.id || !styles || styles.length === 0) {
      return buildImage({
        image: {
          backgroundColor: '#CCC',
          height: 768,
          width: 576,
          layout: 'constrained',
          images: {},
        },
        alt: (image?.alt as string) || '',
        objectPosition,
      });
    }

    const largest = styles.sort((a, b) => (a.width > b.width ? 1 : -1))[
      styles.length - 1
    ];

    return buildImage({
      ...gatsbyProps,
      image: {
        backgroundColor: '#CCC',
        height: largest.height,
        width: largest.width,
        layout: 'constrained',
        images: {
          fallback: {
            src: largest.url,
            sizes,
            srcSet: styles
              .map((style) => `${style.url} ${style.width}w`)
              .join(', '),
          },
        },
      },
      alt: (image?.alt as string) || '',
      objectPosition,
    });
  },
  (image, preset, sizes, gatsbyProps) =>
    (image?.styles[0].sources[0].url as string) +
    preset +
    sizes +
    JSON.stringify(gatsbyProps),
);
